import Api from "repository/Api"
import groupNames from "text/groupNames.json";

export const getProject = async (projectId) => {
    const res = await Api.get(`/projects/${projectId}`);
    return res.data;
};

//calibration

export const getProjectCalibrationData = async (projectId) => {
    const res = await Api.get(`/projects/${projectId}/calibration-data`);
    return res.data.data;
};

export const getModifiedProjectCalibrationData = async (projectId) => {
    const res = await Api.get(`/projects/${projectId}/calibration-data`);
    return {data: res.data.dataModified, id: res.data.id};
};

//map packs

export const getProjectMapPacks = async (projectId) => {
    const res = await Api.get(`/projects/${projectId}/map-packs`);
    return res.data["hydra:member"]
};

/**
 * Retrieve all folder & map structure for this project from the api
 */
export const getProjectMapPackFolders = async (projectId, mapPackName) => {
    const res = await Api.get(`/projects/${projectId}/codenames?pack=${mapPackName}`);
    let folderStructure = res.data.folders["hydra:member"];

    //sanitise groupNames
    folderStructure = folderStructure.map(folder => {
        let groupName = folder.groupName.toLowerCase();
        if (!groupNames.includes(groupName)) groupName = "ungrouped"
        return {...folder, groupName}
    })
    return folderStructure;
};
